import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles((theme) => ({
  rootPopup: {
    padding: "4px",
    border: "2px solid red",
  },
  popupWithTitle: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "relative",
    fontFamily: "Eurostile",
    color: "#201F1E",
    fontSize: "20px",
    fontWeight: 500,
  },
  popupTitle: {
    display: "flex",
    justifyContent: "center",
    fontFamily: "Eurostile",
    color: "#201F1E",
    fontSize: "22px !important",
    fontWeight: 800,
    // paddingTop: "6px !important",
    // paddingBottom: "0px !important",
    padding:'6px 0px !important',
    alignItems: "center",
  },
  labelBox:{
    display: "flex",
    alignItems: "center",
    justifyItems: "center",
    // border:'2px solid #dbdbdb',
    marginTop: "16px !important",
    // background:'#eeecef',
    // paddingTop:'7px !important',
    paddingBottom:'6px',
    paddingLeft:'8px !important',
    borderTopLeftRadius:'5px',
    borderBottomLeftRadius:'5px',
    height: "36px",
    "@media print": {
    // backgroundColor: "#eeecef !important",
    "-webkit-print-color-adjust": "exact", // For Chrome
    "print-color-adjust": "exact", // For Firefox and IE
  },
  },
  titleBox:{
    display: "grid",
    textAlign: "center",
    alignItems: "center",
    justifyItems: "center",
    border:'2px solid #dbdbdb',
    marginTop: "16px !important",
    // background:'#eeecef',
    paddingTop:'0px !important',
    paddingBottom:'0px !important',
    // paddingLeft:'8px !important',
    borderTopLeftRadius:'5px',
    borderBottomLeftRadius:'5px',
    // height: "36px",
  },
  errorText:{
    // position:'fixed',
    // marginTop:'46px !important',
  },
  printicons: {
    position: "absolute",
    margin: "0px 16px",
    right: 138,
    cursor: "pointer",
    height: "26px",
  },

   mailicons: {
    position: "absolute",
    margin: "0px 16px",
    right: 100,
    cursor: "pointer",
    height: "29px",
  },

  checkicons: {
    position: "absolute",
    margin: "0px 16px",
    right: 64,
    cursor: "pointer",
    height: "29px",
  },
  deleteicons: {
    position: "absolute",
    margin: "0px 16px",
    right: 30,
    cursor: "pointer",
    height: "28px",
  },
  closeicons: {
    position: "absolute",
    margin: "0px 10px",
    // marginTop: "4px",
    right: 4,
    cursor: "pointer",
    height: "24px",
  },
  formBox: {
    fontFamily: "Poppins",
    paddingLeft: "0px",
    paddingRight: "0px",
  },
  avatar: {
    width: "68px",
    height: "68px",
  },

  formLinkHeading: {
    marginTop: "8px",
    marginBottom: "0px",
    fontFamily: "Poppins",
    fontWeight: 700,
    color: "#2A2338",
    fontSize: "14px",
    fontStyle: "normal",
  },
  formLinkHeadingValue: {
    marginTop: "0px",
    marginBottom: "8px",
    fontFamily: "Poppins",
    fontWeight: 500,
    color: "#0445AF",
    fontSize: "15px",
    fontStyle: "normal",
  },
  txtForm: {
    padding: "0px 4px",
  },
  modelFooter: {
    fontFamily: "Poppins",
    padding: "4px",
    paddingBottom: "8px",
    paddingRight: "12px",
    paddingLeft: "12px",
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
  },
  blueButton: {
    fontFamily: "Poppins",
    background: "#0078D4",
    color: "#fff",
    fontWeight: 400,
    marginTop: "8px",
    "&:hover": {
      background: "#0078D4",
      color: "#fff",
    },
  },
  gridBox: {
    fontFamily: "Poppins",
    paddingTop: "16px",
    paddingBottom: "16px",
  },
  // inner model
  outlineBtn: {
    textTransform: "none",
    paddingTop: "4px",
    paddingBottom: "4px",
    paddingLeft: "16px",
    paddingRight: "16px",
    height: "32px",
    fontFamily: "Poppins",
    fontSize: "14px",
    fontWeight: 400,
    borderRadius: "2px",
  },
  fillBtn: {
    textTransform: "none",
    paddingTop: "4px",
    paddingBottom: "4px",
    paddingLeft: "16px",
    paddingRight: "16px",
    height: "32px",
    fontFamily: "Poppins",
    fontSize: "14px",
    fontWeight: 500,
    borderRadius: "2px",
  },
  formAddBox: {
    // fontFamily:'Poppins',
  },
  formHeading: {
    marginTop: "8px",
    marginBottom: "0px",
    paddingLeft: "2px",
    fontSize: "12px",
    color: "#4A5568",
    fontWeight: 600,
  },
  dropdownFormControl: {
    border: '1px solid #076C6B',
  },
  selectDropdown: {
    border: "1px solid #DADFEB",
    padding: "4px 10px",
    borderRadius: "5px",
    background: "#fff",
    "&:before": {
        border: '1px solid #DADFEB',
    },
    "&:after": {
        border: '1px solid #076C6B',
    },
    "&:hover:before": {
      border: '1px solid #076C6B',
    },
  },

  checkbox: {
    color: "#02906F",
    "&.Mui-checked": {
      color: "#02906F",
    },
  },
  listItemText: {
    textTransform: "capitalize",
  },

  tableCell: {
    border: '1px solid #dbdbdb',
    textAlign: 'center',
    padding:'2px 4px !important',
  },


}));

export default useStyles;
